import { c as _c } from "react/compiler-runtime";
import { useState, forwardRef } from 'react';
import cx from 'classnames';
import Error from '@mui/icons-material/Error';
import LockIcon from '@mui/icons-material/Lock';
import { TextField as MuiTextField, FormHelperText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';
import { alpha } from '@classify/react-core-components/styles';
export const useStyles = makeStyles(/* istanbul ignore next */({
  breakpoints,
  spacing,
  palette
}) => ({
  textField: {
    marginBottom: spacing(2)
  },
  textInputFullWidth: {
    width: '100%'
  },
  noAsterisk: {
    display: 'none'
  },
  root: {
    color: palette.text.secondary
  },
  focused: {
    color: [palette.primary.main, '!important']
  },
  shrink: {
    fontSize: 14,
    transform: `translate(${spacing(1)}, ${spacing(1)}) scale(0.75) !important`
  },
  formControl: {
    fontSize: 14,
    padding: spacing(3, 1, 1, 1),
    height: 16,
    lineHeight: '16px'
  },
  formControlMultiline: {
    height: 'unset'
  },
  formControlNoLabel: {
    padding: spacing(2, 1, 2, 1),
    minHeight: `initial !important;`
  },
  multiline: {
    paddingLeft: spacing(1),
    paddingRight: spacing(1)
  },
  multilineInput: {
    padding: 0,
    lineHeight: '24px',
    backgroundColor: 'transparent !important'
  },
  multilineNoLabel: {
    // Custom padding to align it with single line inputs
    paddingTop: spacing(1.5),
    paddingBottom: '11px'
  },
  disabled: {
    color: palette.text.secondary,
    'div&': {
      backgroundColor: [alpha(palette.status.inactive, 0.04), '!important']
    }
  },
  filledLabel: {
    transform: `translate(${spacing(1)}, 17px) scale(1)`
  },
  filled: {
    backgroundColor: [alpha(palette.primary.main, 0.04), '!important'],
    '&:hover': {
      backgroundColor: alpha(palette.primary.main, 0.04),
      '&:after': {
        transform: 'scale(1)'
      }
    },
    '& input': {
      backgroundColor: 'transparent !important'
    }
  },
  error: {
    backgroundColor: [alpha(palette.status.danger, 0.04), '!important']
  },
  adornedEnd: {
    color: palette.text.secondary
  },
  inputAdornedEnd: {
    color: 'initial'
  },
  helperContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  maxLength: {
    marginTop: 3,
    whiteSpace: 'nowrap',
    color: palette.text.secondary
  },
  endAdornmentMultiline: {
    alignSelf: 'flex-start'
  },
  [breakpoints.down('sm')]: {
    filledLabel: {
      transform: `translate(${spacing(1)}, 13px) scale(1)`
    }
  }
}), {
  classNamePrefix: 'TextField'
});
const TextField = forwardRef((t0, ref) => {
  const $ = _c(121);
  let name;
  let otherProps;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    ({
      formHelper: t1,
      noAsterisk: t2,
      field: t3,
      onBlur: t4,
      fieldSuggestion: t5,
      inputProps: t6,
      label: t7,
      error: t8,
      name,
      disabled: t9,
      icon: t10,
      fullWidth: t11,
      InputProps: t12,
      className: t13,
      onChange: t14,
      maxLength: t15,
      multiline: t16,
      select: t17,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = name;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t15;
    $[10] = t16;
    $[11] = t17;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    name = $[1];
    otherProps = $[2];
    t1 = $[3];
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t15 = $[9];
    t16 = $[10];
    t17 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  const formHelper = t1 === undefined ? null : t1;
  const noAsterisk = t2 === undefined ? false : t2;
  let t18;
  if ($[20] !== t3) {
    t18 = t3 === undefined ? {} : t3;
    $[20] = t3;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  const field = t18;
  const onBlur = t4 === undefined ? null : t4;
  const fieldSuggestion = t5 === undefined ? null : t5;
  let t19;
  if ($[22] !== t6) {
    t19 = t6 === undefined ? {} : t6;
    $[22] = t6;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  const inputProps = t19;
  const label = t7 === undefined ? null : t7;
  const error = t8 === undefined ? null : t8;
  const disabled = t9 === undefined ? false : t9;
  const icon = t10 === undefined ? null : t10;
  const fullWidth = t11 === undefined ? true : t11;
  let t20;
  if ($[24] !== t12) {
    t20 = t12 === undefined ? {} : t12;
    $[24] = t12;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  const InputProps = t20;
  const className = t13 === undefined ? "" : t13;
  const onChange = t14 === undefined ? _temp : t14;
  const maxLength = t15 === undefined ? null : t15;
  const multiline = t16 === undefined ? false : t16;
  const select = t17 === undefined ? false : t17;
  const classes = useStyles();
  const [currentLength, setCurrentLength] = useState(0);
  let endAdornment = null;
  if (icon) {
    endAdornment = icon;
  } else {
    if (error) {
      let t21;
      if ($[26] !== classes.endAdornmentMultiline || $[27] !== multiline) {
        t21 = cx({
          [classes.endAdornmentMultiline]: multiline
        });
        $[26] = classes.endAdornmentMultiline;
        $[27] = multiline;
        $[28] = t21;
      } else {
        t21 = $[28];
      }
      let t22;
      if ($[29] !== t21) {
        t22 = <Error color="error" fontSize="small" className={t21} />;
        $[29] = t21;
        $[30] = t22;
      } else {
        t22 = $[30];
      }
      endAdornment = t22;
    } else {
      if (disabled) {
        let t21;
        if ($[31] !== classes.endAdornmentMultiline || $[32] !== multiline) {
          t21 = cx({
            [classes.endAdornmentMultiline]: multiline
          });
          $[31] = classes.endAdornmentMultiline;
          $[32] = multiline;
          $[33] = t21;
        } else {
          t21 = $[33];
        }
        let t22;
        if ($[34] !== t21) {
          t22 = <LockIcon className={t21} />;
          $[34] = t21;
          $[35] = t22;
        } else {
          t22 = $[35];
        }
        endAdornment = t22;
      }
    }
  }
  const helperErrorId = `${name}error`;
  const helperId = `${name}helper`;
  let ariaDescribedBy;
  if (error) {
    ariaDescribedBy = helperErrorId;
  } else {
    if (formHelper) {
      ariaDescribedBy = helperId;
    }
  }
  let t21;
  if ($[36] !== className || $[37] !== classes.textField) {
    t21 = cx(classes.textField, className);
    $[36] = className;
    $[37] = classes.textField;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  const t22 = `field${name}`;
  const t23 = fullWidth ? classes.textInputFullWidth : null;
  const t24 = Boolean(error);
  let t25;
  if ($[39] !== maxLength || $[40] !== onChange) {
    t25 = e => {
      if (maxLength) {
        setCurrentLength(e.target.value?.length);
      }
      onChange(e);
    };
    $[39] = maxLength;
    $[40] = onChange;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  const t26 = endAdornment;
  let t27;
  if ($[42] !== field || $[43] !== onBlur) {
    t27 = evt => {
      if (field.onBlur) {
        field.onBlur(evt);
      }
      if (onBlur) {
        onBlur(evt);
      }
    };
    $[42] = field;
    $[43] = onBlur;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== classes.formControl || $[46] !== classes.formControlMultiline || $[47] !== classes.formControlNoLabel || $[48] !== label || $[49] !== multiline) {
    t28 = cx(classes.formControl, {
      [classes.formControlNoLabel]: !label
    }, {
      [classes.formControlMultiline]: multiline
    });
    $[45] = classes.formControl;
    $[46] = classes.formControlMultiline;
    $[47] = classes.formControlNoLabel;
    $[48] = label;
    $[49] = multiline;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  const t29 = !disabled ? classes.filled : null;
  const t30 = classes.error;
  const t31 = !label;
  let t32;
  if ($[51] !== classes.multiline || $[52] !== classes.multilineNoLabel || $[53] !== t31) {
    t32 = cx(classes.multiline, {
      [classes.multilineNoLabel]: t31
    });
    $[51] = classes.multiline;
    $[52] = classes.multilineNoLabel;
    $[53] = t31;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  let t33;
  if ($[55] !== classes.adornedEnd || $[56] !== classes.disabled || $[57] !== classes.error || $[58] !== classes.inputAdornedEnd || $[59] !== classes.multilineInput || $[60] !== t28 || $[61] !== t29 || $[62] !== t32) {
    t33 = {
      input: t28,
      root: t29,
      error: t30,
      multiline: t32,
      inputMultiline: classes.multilineInput,
      disabled: classes.disabled,
      adornedEnd: classes.adornedEnd,
      inputAdornedEnd: classes.inputAdornedEnd
    };
    $[55] = classes.adornedEnd;
    $[56] = classes.disabled;
    $[57] = classes.error;
    $[58] = classes.inputAdornedEnd;
    $[59] = classes.multilineInput;
    $[60] = t28;
    $[61] = t29;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== ariaDescribedBy || $[65] !== inputProps || $[66] !== maxLength) {
    t34 = {
      maxLength,
      "aria-describedby": ariaDescribedBy,
      ...inputProps
    };
    $[64] = ariaDescribedBy;
    $[65] = inputProps;
    $[66] = maxLength;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== InputProps || $[69] !== endAdornment || $[70] !== t27 || $[71] !== t33 || $[72] !== t34) {
    t35 = {
      endAdornment: t26,
      onBlur: t27,
      classes: t33,
      inputProps: t34,
      ...InputProps
    };
    $[68] = InputProps;
    $[69] = endAdornment;
    $[70] = t27;
    $[71] = t33;
    $[72] = t34;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== classes.noAsterisk || $[75] !== noAsterisk) {
    t36 = noAsterisk ? {
      asterisk: classes.noAsterisk
    } : {};
    $[74] = classes.noAsterisk;
    $[75] = noAsterisk;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== classes.filledLabel || $[78] !== classes.focused || $[79] !== classes.root || $[80] !== classes.shrink || $[81] !== t36) {
    t37 = {
      classes: {
        ...t36,
        root: classes.root,
        focused: classes.focused,
        shrink: classes.shrink,
        filled: classes.filledLabel
      }
    };
    $[77] = classes.filledLabel;
    $[78] = classes.focused;
    $[79] = classes.root;
    $[80] = classes.shrink;
    $[81] = t36;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== t35 || $[84] !== t37) {
    t38 = {
      input: t35,
      inputLabel: t37
    };
    $[83] = t35;
    $[84] = t37;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  let t39;
  if ($[86] !== disabled || $[87] !== label || $[88] !== multiline || $[89] !== name || $[90] !== otherProps || $[91] !== ref || $[92] !== select || $[93] !== t22 || $[94] !== t23 || $[95] !== t24 || $[96] !== t25 || $[97] !== t38) {
    t39 = <MuiTextField ref={ref} id={t22} name={name} className={t23} variant="filled" error={t24} label={label} disabled={disabled} onChange={t25} multiline={multiline} select={select} {...otherProps} slotProps={t38} />;
    $[86] = disabled;
    $[87] = label;
    $[88] = multiline;
    $[89] = name;
    $[90] = otherProps;
    $[91] = ref;
    $[92] = select;
    $[93] = t22;
    $[94] = t23;
    $[95] = t24;
    $[96] = t25;
    $[97] = t38;
    $[98] = t39;
  } else {
    t39 = $[98];
  }
  let t40;
  if ($[99] !== error || $[100] !== helperErrorId) {
    t40 = error && <FormHelperText id={helperErrorId} error={true}>{error}</FormHelperText>;
    $[99] = error;
    $[100] = helperErrorId;
    $[101] = t40;
  } else {
    t40 = $[101];
  }
  let t41;
  if ($[102] !== formHelper || $[103] !== helperId) {
    t41 = formHelper && <FormHelperText id={helperId}>{formHelper}</FormHelperText>;
    $[102] = formHelper;
    $[103] = helperId;
    $[104] = t41;
  } else {
    t41 = $[104];
  }
  let t42;
  if ($[105] !== t40 || $[106] !== t41) {
    t42 = <div>{t40}{t41}</div>;
    $[105] = t40;
    $[106] = t41;
    $[107] = t42;
  } else {
    t42 = $[107];
  }
  let t43;
  if ($[108] !== classes.maxLength || $[109] !== currentLength || $[110] !== maxLength) {
    t43 = maxLength && <Typography variant="caption" className={classes.maxLength}>{`${currentLength}/${maxLength}`}</Typography>;
    $[108] = classes.maxLength;
    $[109] = currentLength;
    $[110] = maxLength;
    $[111] = t43;
  } else {
    t43 = $[111];
  }
  let t44;
  if ($[112] !== classes.helperContainer || $[113] !== t42 || $[114] !== t43) {
    t44 = <div className={classes.helperContainer}>{t42}{t43}</div>;
    $[112] = classes.helperContainer;
    $[113] = t42;
    $[114] = t43;
    $[115] = t44;
  } else {
    t44 = $[115];
  }
  let t45;
  if ($[116] !== fieldSuggestion || $[117] !== t21 || $[118] !== t39 || $[119] !== t44) {
    t45 = <div className={t21}>{t39}{fieldSuggestion}{t44}</div>;
    $[116] = fieldSuggestion;
    $[117] = t21;
    $[118] = t39;
    $[119] = t44;
    $[120] = t45;
  } else {
    t45 = $[120];
  }
  return t45;
});
export default TextField;
function _temp() {}